<template>
    <div data-cy="container_mission_transaction_progress">
        <div v-if="missionOneTime" class="w-full border border-a-yellow-ffca66 rounded-full py-0.5 pl-0.5 pr-3 mt-4 relative">
            <div>
                <div class="bg-a-gray-e2e2e2 h-2 rounded-full">
                    <div :style="{'width': `${calculateOneTimePercent(transactionMission)}%`}"
                        class="bg-a-yellow-ffca66 h-2 border-a-yellow-ffca66 rounded-full">
                    </div>
                </div>
                <div class="absolute -top-3 -right-2">
                    <div class="relative">
                        <img :src="getFlagIcon('pink')" alt="" v-if="missionSuccess">
                        <img :src="getFlagIcon('gray')" alt="" v-else>
                        <div class="text-flag absolute text-6 text-white">
                            {{missionOneTime}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="relative">
                <div class="splide" :id="`progress-slide-month-${indexItems}`">
                    <div class="splide__track">
                        <ul class="splide__list ">
                            <li class="splide__slide pt-5 pr-1"
                                v-for="(subMission, index) in transactionMission.SubMissions"
                                :key="subMission">
                                <div class="flex items-center relative -mr-0.5">
                                    <div class="w-full">
                                        <div class="item-progress bg-white border relative z-0"
                                            :class="[index == 0 ? 'first' : index == subMission.length-1 ? 'last' : '', indexActive == index ? 'border-a-yellow-ffca66' : 'border-a-gray-e2e2e2']">
                                            <div class="item-progress-bg rounded-full h-2">
                                                <div class="bg-a-gray-e2e2e2 h-2 rounded-full" v-if="isMission7">
                                                    <div class="bg-a-yellow-ffca66 h-2 border-a-yellow-ffca66"
                                                    :class="[calculatePercentWithMaxLevel(subMission) == 100 ? 'rounded-full' : 'rounded-l-full']"
                                                    :style="{'width': `${calculatePercentWithMaxLevel(subMission)}%`}">
                                                        <div class="grid h-2 absolute size-box"
                                                            :class="`grid-cols-${transactionMission.MaxLevel}`">
                                                            <div v-for="(item) in transactionMission.MaxLevel" :key="item"
                                                                class="border-r h-2 last:border-0"
                                                                :class="[flagCompleted[index] ? 'border-a-pink-ff6699' : 'border-a-gray-c4c4c4']">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="bg-a-gray-e2e2e2 h-2 rounded-full" v-else>
                                                    <div :style="{'width': `${calculatePercent(subMission)}%`}"
                                                        class="bg-a-yellow-ffca66 h-2 border-a-yellow-ffca66 rounded-full">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="wrapper-flag">
                                            <img :src="getFlagIcon('pink')" alt="" v-if="flagCompleted[index]">
                                            <img :src="getFlagIcon('gray')" alt="" v-else>
                                            <div class="text-flag absolute text-6 text-white">
                                                {{index+1}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="splide__arrows relative">
                        <div class="splide__arrow splide__arrow--prev" v-if="transactionMission.SubMissions.length > 3">
                            <img v-if="currentPage != 0" data-cy="btn_mission_transaction_progress_prev" @click="btnPrev()" :src="getArrowIcon('left', 'active')">
                            <img v-else data-cy="btn_mission_transaction_progress_prev_disabled" :src="getArrowIcon('left', 'inactive')">
                        </div>
                        <div class="box-page">
                            <div class="absolute -top-8 left-0 right-0 m-auto flex items-center justify-center text-12 font-normal px-2" :class="[transactionMission.UI == null? 'text-a-blue-2140a6': 'text-white']">
                                <div>
                                    {{ lbl.mission.month }}
                                </div>
                                <div class="font-bold text-a-yellow-ffca66 pl-1">
                                    {{ isActive+1 }}
                                </div>
                                <div>
                                    /{{transactionMission.SubMissions.length}}
                                </div>
                            </div>
                        </div>
                        <div class="splide__arrow splide__arrow--next" v-if="transactionMission.SubMissions.length > 3">
                            <img v-if="currentPage != transactionMission.SubMissions.length-3" data-cy="btn_mission_transaction_progress_next" @click="btnNext()" :src="getArrowIcon('right', 'active')">
                            <img v-else data-cy="btn_mission_transaction_progress_next_disabled" :src="getArrowIcon('right', 'inactive')">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Splide from '@splidejs/splide'; //https://splidejs.com/
import ConfigManager from '@/config/ConfigManager.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
export default {
    name: 'ProgressBarMission',
    mixins: [LocaleMixin],
    props: {
        transactionMission:     { type: Object, required: true },
        missionSuccess:         { type: Boolean, default: false },
        indexItems:             { type: Number, required: false },
        indexActive:            { type: Number, required: false   },
    },
    data: function() {
        return {
            slider: null,
            isActive: 0,
            missionOneTime: 0,
            currentPage: 0,
            flagCompleted: false,
            isMission7: false,
            isPaging: false,
        }
    },
    created: function() {
        this.checkMission();
    },
    methods: {
        checkMission: function() {
            if(parseInt(this.transactionMission.Id) == 7){
                this.isMission7 = true;
            }

            if (this.transactionMission.SubMissions) {
                this.isActive = this.indexActive;
                this.flagCompleted = this.transactionMission.SubMissions.filter((completed) =>{
                    return completed.Completed
                });

                if (this.transactionMission.SubMissions.length > 3) {
                    this.isPaging = true;
                }

                this.setSlider();
            }
            if (this.transactionMission.MissionCount) {
                this.missionOneTime = this.transactionMission.MissionCount;
            }
        },
        calculateOneTimePercent: function(mission){
            let oneTime = mission.Count || 0;
            let missionCount = mission.MissionCount || 0;
            return (oneTime / missionCount) * 100;
        },
        calculatePercent: function(subMissions) {
            if (subMissions) {
                return (subMissions.Count / subMissions.MissionCount) * 100;
            } else {
                return 0
            }
        },
        calculatePercentWithMaxLevel: function(subMissions) {
            let missionAll = subMissions.MissionCount * this.transactionMission.MaxLevel;
            let missionCurrent = subMissions.CurrentLevel * subMissions.Count;
            let progress = (missionCurrent / missionAll) * 100;

            if (subMissions.Count == 0 && subMissions.CurrentLevel == undefined) {
                return 0;
            }
            // if (count == 7) {
            //     return progress
            // }
            if (subMissions && subMissions.CurrentLevel == 0) {
                let progressLevel0 = (subMissions.Count / missionAll) * 100
                return progressLevel0;
            } else if (subMissions && subMissions.CurrentLevel == 1) {
                if (subMissions.Count == 7) {
                    return progress;
                } else {
                    return progress + 33.33;
                }
            }  else if (subMissions && subMissions.CurrentLevel == 2) {
                if (subMissions.Count == 0) {
                    return progress + 66.5;
                } else if (subMissions.Count == 1) {
                    return progress + 62;
                } else if (subMissions.Count == 2) {
                    return progress + 55;
                } else if (subMissions.Count == 3) {
                    return progress + 50;
                } else if (subMissions.Count == 4) {
                    return progress + 45;
                } else if (subMissions.Count == 5) {
                    return progress + 40;
                } else if (subMissions.Count == 6) {
                    return progress + 35;
                } else {
                    return progress;
                }
            } else {
                return 100;
            }

            // let missionAll = subMissions.MissionCount * this.transactionMission.MaxLevel;
            // let missionCurrent = subMissions.CurrentLevel * subMissions.Count;
            // console.log('missionAll', missionAll)

            // if(subMissions && subMissions.CurrentLevel == 0){
            //     console.log((missionCurrent / missionAll) * 100);
            //     console.log(subMissions.Count);
            //     return (missionCurrent / missionAll) * 100;
            //     // return subMissions.Count
            // } else {
            //     return 0
            // }
        },
        setSlider: function() {
            this.$nextTick(() => {
                this.slider = new Splide(`#progress-slide-month-${this.indexItems}`, {
                    type: 'slide',
                    arrows: this.isPaging,
                    autoplay: false,
                    perPage: 3,
                    perMove: 1,
                    drag: false,
                    start: this.isActive,
                    focus: 0,
                    pagination: false,
                    omitEnd: true,
                    padding: {right: '10px'}
                }).mount();
            });
        },
        btnNext: function() {
            if (this.currentPage == (this.transactionMission.SubMissions.length-3)) return;
            this.currentPage++;
        },
        btnPrev: function() {
            if (this.currentPage == 0) return;
            this.currentPage--;
        },
        getFlagIcon: function(color) {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/mission/transaction/ic-${color}-flag.svg`;
        },
        getArrowIcon: function(direction, state) {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/icons/ic-arrow-${direction}-${state}.svg`;
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
.box-border-t-yellow {
    position: absolute;
    top: -1.25px;
    left: 5px;
}
.box-border-b-yellow {
    position: absolute;
    bottom: -1px;
    left: 5px;
}
.text-flag{
    top: 15px;
    left: 5px;
}
.wrapper-flag{
    position: absolute;
    right: -12px;
    top: -12px;
    z-index: 100;
}
.item-progress{
    border-top-width: 1px;
    border-bottom-width: 1px;
    border-left: none;
    border-right: none;
    padding: {
        top: 1px;
        bottom: 1px;
    };

    .item-progress-bg{
        margin: {
            left: 5px;
            right: 8px;
        };

        .size-box {
            width: 82.5%;
            @include size-mini-mobile {
                width: 79%;
            }
            @include size-375-mobile {
                width: 80%;
            }
        }
    }

    &.first{
        padding-left: 2px;
        border-top-width: 1px;
        border-bottom-width: 1px;
        border-left-width: 1px;
        border-top-left-radius: 9999px;
        border-bottom-left-radius: 9999px;

        .item-progress-bg{
            margin: {
                left: 0px;
                right: 8px;
            };
            .size-box {
                width: 85.5%;
                @include size-mini-mobile {
                    width: 84%;
                }
            }
        }
    }
    &.last{
        border-top-width: 1px;
        border-bottom-width: 1px;
        border-right-width: 1px;
        border-top-right-radius: 9999px;
        border-bottom-right-radius: 9999px;
    }
}
.splide__arrows {
    margin-top: 50px;
    .splide__arrow {
        background-color: rgba(255, 255, 255, 0);
    }
    .splide__arrow--prev {
        left: 0;
        top: -25px;
        opacity: 1;
    }
    .splide__arrow--next {
        right: 0;
        top: -25px;
        opacity: 1;
    }
    .box-page {
        top: -2.3rem;
    }
}
</style>
